import {AxiosError} from 'axios';
import {errorMaps, localizedErrorMaps} from './errorMessages';
export interface BackendErrorData {
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
}

export function parseApiError(
  error: AxiosError<BackendErrorData>,
  module?: string
): AxiosError<BackendErrorData> {
  const detail = error?.response?.data?.detail;
  const code = detail?.split('\n')[0]?.trim().replace(' :', '');

  const mappedMessage =
    code && module && errorMaps[module]?.[code]
      ? errorMaps[module][code]
      : error.message;

  error.message = mappedMessage;
  error.code = code;

  return error;
}

export function parseApiErrorWithLocalization(
  error: AxiosError<BackendErrorData>,
  module: string
): AxiosError<BackendErrorData> {
  const detail = error?.response?.data?.detail;
  const code = detail?.split('\n')[0]?.trim();

  let mappedMessage = localizedErrorMaps(module, code || '');
  mappedMessage =
    code && module && mappedMessage ? mappedMessage : error.message;

  error.message = mappedMessage;
  error.code = code;

  return error;
}

export function parseApiErrorWithoutCode(
  error: AxiosError<BackendErrorData>
): AxiosError<BackendErrorData> {
  const detail = error?.response?.data?.detail;
  error.message = detail?.split('\n')[0]?.trim() || error.message;
  return error;
}
